import React, {Component} from 'react';
import * as R from 'ramda';
import t from 'tcomb-form';
import classNames from 'classnames';

import 'scss/form/component/form_content_specialty';

export default class FormContentSpecialty extends Component {
    constructor(props) {
        super(props);

        const contentSpecialties = this.getSpecialtyState(props.value);

        this.state = {
            ...contentSpecialties,
            hasError: false
        };
    }

    getSpecialtyState = value => {
        if (R.isNil(value)) {
            return {
                hasImageSpecialty: false,
                hasVideoSpecialty: false,
                hasBlogPostSpecialty: false
            };
        }

        return R.reduce(
            (specialtyState, specialty) => {
                if (specialty === 'images') specialtyState.hasImageSpecialty = true;
                if (specialty === 'videos') specialtyState.hasVideoSpecialty = true;
                if (specialty === 'blog_posts') specialtyState.hasBlogPostSpecialty = true;

                return specialtyState;
            },
            {},
            value
        );
    };

    handleInputChange = e => {
        const target = e.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({[name]: value}, () =>
            this.props.onChange(this.getContentSpecialtyData(), this.props.ctx.path)
        );
    };

    getContentSpecialtyData = () => {
        const {hasImageSpecialty, hasVideoSpecialty, hasBlogPostSpecialty} = this.state;

        const contentSpecialties = [];
        if (hasImageSpecialty) {
            contentSpecialties.push('images');
        }

        if (hasVideoSpecialty) {
            contentSpecialties.push('videos');
        }

        if (hasBlogPostSpecialty) {
            contentSpecialties.push('blog_posts');
        }

        return contentSpecialties.length > 0 ? contentSpecialties : null;
    };

    getValidationOptions = () => ({
        path: this.props.ctx.path,
        context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
            options: this.props.options
        })
    });

    validate = () => {
        const contentSpecialtyData = this.getContentSpecialtyData();
        const result = t.validate(
            contentSpecialtyData,
            this.props.type,
            this.getValidationOptions()
        );

        this.setState({
            hasError: !result.isValid()
        });

        return result;
    };

    render() {
        const {hasImageSpecialty, hasVideoSpecialty, hasBlogPostSpecialty, hasError} = this.state;
        const label = this.props.options.label || this.props.ctx.label;

        return (
            <div className={classNames('form-group', hasError && 'has-error')}>
                <div className="form-content-specialty">
                    <label className="control-label">{label}</label>

                    <div className="content-specialty-selection">
                        <div className="content-specialty-select">
                            <input
                                className="content-specialty-checkbox"
                                type="checkbox"
                                name="hasImageSpecialty"
                                checked={hasImageSpecialty}
                                onChange={this.handleInputChange}
                            />
                            <div className="content-specialty-text">Images</div>
                        </div>
                        <div className="content-specialty-select">
                            <input
                                className="content-specialty-checkbox"
                                type="checkbox"
                                name="hasVideoSpecialty"
                                checked={hasVideoSpecialty}
                                onChange={this.handleInputChange}
                            />
                            <div className="content-specialty-text">Videos</div>
                        </div>
                        <div className="content-specialty-select">
                            <input
                                className="content-specialty-checkbox"
                                type="checkbox"
                                name="hasBlogPostSpecialty"
                                checked={hasBlogPostSpecialty}
                                onChange={this.handleInputChange}
                            />
                            <div className="content-specialty-text">Blog Posts</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_content_specialty.js